import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { Link } from 'react-router-dom';

const LearnMore = ({handleChatToggle}) => {
  return (
    <Container className="mt-5">
      <Row className="mb-4">
        <Col>
          <h1 className="display-4 text-primary">Erfahren Sie mehr: Wie unser KI-Assistent Ihnen hilft, das perfekte Geschenk zu finden</h1>
          <p className="lead text-muted">
            Bei <strong>Present-Bot</strong> glauben wir, dass das Finden des perfekten Geschenks einfach, unterhaltsam und personalisiert sein sollte. 
            Deshalb haben wir einen KI-gesteuerten Assistenten entwickelt, der Ihnen dabei hilft, durchdachte und einzigartige Geschenke für Ihre Liebsten zu entdecken – egal zu welchem Anlass.
          </p>
        </Col>
      </Row>

      {/* Abschnitt: Was machen wir? */}
      <Row className="mb-5">
        <Col>
          <h2 className="text-secondary">Was machen wir?</h2>
          <p className="text-muted">
            Unser KI-Assistent verwendet modernste Technologie, um Ihre Vorlieben und die der Personen, für die Sie einkaufen, zu verstehen. 
            Durch die Analyse von Details wie Interessen, Hobbys bietet unsere KI personalisierte Empfehlungen, die auf jede Person, die Sie beschenken wollen, abgestimmt sind. 
            Egal, ob es sich um einen Geburtstag, einen Feiertag oder ein besonderes Ereignis handelt, unser Assistent macht die Suche einfach und bietet kuratierte Geschenkideen, die zu der Persönlichkeit und den Bedürfnissen des Empfängers passen.
          </p>
        </Col>
      </Row>

      {/* Abschnitt: Warum ist das wichtig? */}
      <Row className="mb-5">
        <Col>
          <h2 className="text-secondary">Warum ist das wichtig?</h2>
          <p className="text-muted">
          Das perfekte Geschenk zu finden, kann oft stressig und zeitaufwendig sein. Viele von uns tun sich manchmal schwer, kreative und persönliche Ideen zu entwickeln oder suchen einfach nach inspirierenden Anregungen.
            Unser KI-Assistent hilft Ihnen, diese Last abzunehmen, indem er Ihnen sorgfältig ausgewählte Optionen präsentiert, die Ihren Anforderungen entsprechen. 
            Durch den Einsatz von KI helfen wir, schlagen wir durchdachte und passende Geschenke vor.
          </p>
        </Col>
      </Row>

      {/* Abschnitt: Die Herausforderungen */}
      <Row className="mb-5">
        <Col>
          <h2 className="text-secondary">Die Herausforderungen</h2>
          <p className="text-muted">
            Die Entwicklung einer KI, die menschliche Vorlieben versteht, ist nicht herausfordernd. Persönliche Geschmäcker sind sehr unterschiedlich, und die Vorhersage dessen, was jemand schätzen könnte, erfordert die Analyse sowohl objektiver Daten (z.B. Preis, Anlass) als auch subjektiver Elemente (z.B. emotionaler Wert, kulturelle Bedeutung).
            Eine weitere Herausforderung besteht darin, sicherzustellen, dass die KI anpassungsfähig bleibt und im Laufe der Zeit aus Interaktionen lernt und sich verbessert. 
            Geschenkempfehlungen sind persönlich, daher müssen wir sicherstellen, dass unser Assistent lernt, individuell auf die Nutzer einzugehen und gleichzeitig ihre Privatsphäre und Datensicherheit respektiert.
          </p>
        </Col>
      </Row>

      {/* Abschnitt: Was kommt als nächstes? */}
      <Row className="mb-5">
        <Col>
          <h2 className="text-secondary">Was kommt als nächstes?</h2>
          <p className="text-muted">
            In Zukunft planen wir, die Fähigkeiten unseres KI-Assistenten durch die Integration fortschrittlicherer Empfehlungsalgorithmen und die Erweiterung der analysierten Datenquellen zu verbessern. 
            Wir möchten das Erlebnis noch interaktiver gestalten, indem wir es den Nutzern ermöglichen, direktes Feedback zu den Empfehlungen zu geben, um diese weiter zu personalisieren.
          </p>
          <p className="text-muted">
            In Zukunft hoffen wir auch, Funktionen einzuführen, mit denen Sie Ihre Geschenkhistorie nachverfolgen, Erinnerungen an bevorstehende Anlässe einrichten und sogar mit anderen an Gruppengeschenken zusammenarbeiten können. 
            Unser Ziel ist es, **Present-Bot** nicht nur zu einem hilfreichen Tool für das Auffinden von Geschenken zu machen, sondern zu einem unverzichtbaren Teil Ihres Geschenke-Erlebnisses.
          </p>
        </Col>
      </Row>

      {/* Call to Action */}
      <Row className="text-center mb-5">
        <Col>
          <h2 className="text-secondary">Starten Sie Ihre Reise noch heute!</h2>
          <p className="text-muted">
            Werden Sie Teil unserer Gemeinschaft und lassen Sie sich von unserem Assistenten zu Ihrem perfekten Geschenk führen.
          </p>
          <Button variant="primary" size="lg" className="me-3" onClick={handleChatToggle}>
            Jetzt starten
          </Button>
          <LinkContainer to="/contact">
            <Button variant="outline-secondary" size="lg" to="/contact">
                Kontaktieren Sie uns
            </Button>
          </LinkContainer>
        </Col>
      </Row>
    </Container>
  );
};

export default LearnMore;